import ServicePageLayout from '../../components/feature/ServicePageLayout';

const RollerBlindsPage = () => {
  return (
    <ServicePageLayout
      blindType="Roller Blinds"
      heroTitle="Roller Blinds Northampton"
      heroSubtitle="Modern, Stylish & Affordable Roller Blinds"
      introText="Transform your Northampton home with our premium roller blinds. Available in hundreds of fabrics, colours and patterns, roller blinds offer a sleek, modern solution for any room. From blackout to sheer, thermal to waterproof – we have the perfect roller blind for your needs."
      heroImage="https://public.readdy.ai/ai/img_res/2064e0b05f2ab688df5638724ed6fe9e.jpg"
      features={[
        { icon: 'ri-palette-line', title: 'Huge Fabric Choice', desc: 'Choose from hundreds of fabrics, colours and patterns to match your décor perfectly' },
        { icon: 'ri-moon-line', title: 'Blackout Options', desc: 'Complete light control with our premium blackout roller blinds for bedrooms' },
        { icon: 'ri-temp-cold-line', title: 'Thermal Insulation', desc: 'Energy-efficient thermal fabrics help keep your home warm in winter and cool in summer' },
        { icon: 'ri-drop-line', title: 'Moisture Resistant', desc: 'Waterproof roller blinds perfect for bathrooms and kitchens' },
        { icon: 'ri-tools-line', title: 'Easy Operation', desc: 'Smooth chain or spring mechanism for effortless daily use' },
        { icon: 'ri-home-smile-line', title: 'Perfect for Any Room', desc: 'Versatile design suits living rooms, bedrooms, kitchens, bathrooms and offices' },
      ]}
      pricePerBlind="£109"
      wholeHousePrice="£849"
      benefits={[
        { icon: 'ri-check-line', text: 'Hundreds of fabric choices' },
        { icon: 'ri-check-line', text: 'Blackout options available' },
        { icon: 'ri-check-line', text: 'Waterproof fabrics' },
        { icon: 'ri-check-line', text: 'Professional installation' },
        { icon: 'ri-check-line', text: 'Unbeatable prices' },
      ]}
      faqs={[
        {
          question: 'What types of roller blind fabrics do you offer?',
          answer: 'We offer a huge range including blackout, dim-out, sheer, thermal, waterproof, patterned and plain fabrics in hundreds of colours. Our team will help you choose the perfect fabric for each room.'
        },
        {
          question: 'Are roller blinds suitable for bathrooms and kitchens?',
          answer: 'Absolutely! We supply moisture-resistant and waterproof roller blind fabrics specifically designed for high-humidity areas like bathrooms and kitchens.'
        },
        {
          question: 'How do roller blinds operate?',
          answer: 'Our roller blinds come with either a smooth chain mechanism or spring-loaded system. Both options are easy to use and built to last for years of daily operation.'
        },
        {
          question: 'Can I get blackout roller blinds for my bedroom?',
          answer: 'Yes! Our blackout roller blinds provide complete light control, making them perfect for bedrooms, nurseries and media rooms where you need total darkness.'
        },
        {
          question: 'How long does installation take?',
          answer: 'Most roller blind installations take just 15-20 minutes per window. Our experienced installers work efficiently to minimize disruption to your day.'
        },
        {
          question: 'Do you offer a warranty on roller blinds?',
          answer: 'Yes, all our roller blinds come with a manufacturer warranty covering defects in materials and workmanship. We also guarantee our professional installation.'
        },
      ]}
      additionalContent={
        <section className="py-10 sm:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                  The Most Popular Blind Choice in Northampton
                </h3>
                <p className="text-gray-700 mb-6">
                  Roller blinds are the UK's most popular window covering – and for good reason. They offer unbeatable versatility, modern style and practical functionality at an affordable price. Whether you need complete blackout for better sleep, sheer fabrics for privacy with light, or thermal options to reduce energy bills, roller blinds deliver. Our expert team serves homes across Northampton, offering professional measuring, supply and installation of premium roller blinds that are built to last.
                </p>
              </div>
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=stylish%20modern%20roller%20blind%20in%20contemporary%20bedroom%20with%20blackout%20fabric%20smooth%20clean%20lines%20elegant%20interior%20design%20warm%20neutral%20tones%20no%20people%20professional%20photography&width=800&height=600&seq=roller-add-001&orientation=landscape"
                  alt="Roller Blinds in Bedroom"
                  className="w-full h-64 object-cover"
                />
              </div>
            </div>
          </div>
        </section>
      }
    />
  );
};

export default RollerBlindsPage;